import {
  BannerCpcResponse,
  BannerCpcTask,
  BannerCpcStatus,
} from './types/banner-cpc';
import { Task, TaskStatus } from '../../types';

export class BannerCpcAdapter {
  static adaptTasks(response: BannerCpcResponse): Task[] {
    console.log('[CPC] adaptTasks input:', response);
    const firstTaskId = response.tasks?.[0]?.id;
    console.log('[CPC] Первый id задачи:', firstTaskId);
    console.log('🔄 BannerCpcAdapter.adaptTasks - start', response);

    if (!response.tasks || !Array.isArray(response.tasks)) {
      console.warn('⚠️ Некорректный формат ответа от Banner CPC:', response);
      return [];
    }

    const mapBannerCpcStatusToTaskStatus = (
      status: BannerCpcStatus,
    ): TaskStatus => {
      switch (status) {
        case BannerCpcStatus.Active:
          return 'NOT_STARTED';
        case BannerCpcStatus.Completed:
        case BannerCpcStatus.Claim:
          return 'DONE';
        case BannerCpcStatus.Expired:
        case BannerCpcStatus.Sleep:
          return 'SLEEP';
        default:
          return 'NOT_STARTED';
      }
    };

    return response.tasks.slice(0, 10).map((task: BannerCpcTask) => {
      // Преобразуем статус из API в статус Task
      let status: TaskStatus = mapBannerCpcStatusToTaskStatus(
        task.status as BannerCpcStatus,
      );
      let buttonText = 'Подписаться';

      switch (task.status) {
        case 'active':
          status = 'NOT_STARTED';
          buttonText = 'Выполнить';
          break;
        case 'completed':
          status = 'DONE';
          buttonText = 'Выполнено';
          break;
        case 'claim':
          status = 'DONE';
          buttonText = 'Собрать';
          break;
        case 'expired':
          status = 'NOT_STARTED';
          buttonText = 'Подписаться';
          break;
        case 'sleep':
          status = 'SLEEP';
          buttonText = 'Выполнено';
          break;
      }

      return {
        id: String(task.id),
        title: task.view_details.title,
        type: 'sponsors',
        rewards: {
          stars: task.rewards.stars,
        },
        status,
        buttonText,
        provider: 'BANNER_CPC',
        visibility: true,
        progress: {
          current: task.user_progress,
          total: task.target_progress,
          // total: 10,
        },
        date_end: task.details.sleep_time_end,
      };
    });
  }
}
